import { render, staticRenderFns } from "./page_top.vue?vue&type=template&id=2e9dac86&scoped=true&"
import script from "./page_top.vue?vue&type=script&lang=js&"
export * from "./page_top.vue?vue&type=script&lang=js&"
import style0 from "./page_top.vue?vue&type=style&index=0&id=2e9dac86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9dac86",
  null
  
)

export default component.exports